export enum TrackingStageEnum {
    FormCreated = 1,
    QuoteSubmitted = 2
}
